// extracted by mini-css-extract-plugin
export default {"playButtonOverlay":"VideoCard_playButtonOverlay__I7PQr","playButton":"VideoCard_playButton__zjKj7","contentCard":"VideoCard_contentCard__hkDpZ","pulse":"VideoCard_pulse__fYCxa"};